{
  "文件上传配置": "File upload settings",
  "单文件大小上限": "Maximum file size",
  "压缩图片": "Compress images",
  "限制上传文件大小，图片压缩后校验；默认 5 MB，1 MB = 1024 × 1024 字节。": "Limits uploaded file size, checked after image compression. Defaults to 5 MB; 1 MB = 1024 × 1024 bytes.",
  "上传前在浏览器中压缩 JPEG、PNG、WebP 图片。": "Compress JPEG, PNG and WebP images in the browser before upload.",
  "已开启": "Enabled",
  "已关闭": "Disabled",
  "企业认证引导图": "Company verification guide images",
  "企业工作台轮播图片，最多 10 张，保存后刷新页面生效。": "Business workspace carousel images, up to 10. Save and refresh the page to apply.",
  "引导图配置无效，请重置后重新上传": "The guide image configuration is invalid. Reset it and upload the images again.",
  "图片上传失败，请重试": "Image upload failed. Please try again.",
  "上下拖拽调整顺序": "Drag up or down to reorder",
  "拖拽排序": "Drag to reorder",
  "上移第 {{index}} 张图片": "Move image {{index}} up",
  "下移第 {{index}} 张图片": "Move image {{index}} down",
  "点击或拖入图片": "Click or drop an image here",
  "请每次上传一张图片": "Upload one image at a time",
  "按商家端语言展示，英文未上传时使用中文图片": "Shown in the merchant’s language. Uses the Chinese image when no English image is uploaded.",
  "添加引导图": "Add guide image",
  "中文图片": "Chinese image",
  "English 图片": "English image",
  "引导图 {{index}}": "Guide image {{index}}",
  "删除第 {{index}} 张引导图": "Delete guide image {{index}}",
  "跳转设置": "Link settings",
  "跳转地址": "Destination",
  "不跳转": "No link",
  "内链": "Internal link",
  "外链": "External link",
  "未上传时使用中文图片及其跳转地址": "Uses the Chinese image and its link when no English image is uploaded.",
  "内链须为以 / 开头的站内路径": "Enter an internal path starting with /.",
  "外链须为不含账号密码的 HTTP 或 HTTPS 完整网址": "Enter a full HTTP or HTTPS URL without credentials.",
  "保存配置": "Save configuration",
  "删除图片": "Remove image"
}
